<template>
    <div>
        <lessons-table-header :lessons="lessons" v-if="lessons && students.length">
        </lessons-table-header>
        <lessons-table v-if="students.length > 0" :students="students" :hover="false">
            <template v-slot:lesson="props">
                <training-cell :value="props.lesson.state" :dark="$vuetify.theme.dark">
                </training-cell>
            </template>
            <template v-slot:student="props">
                <v-badge dot overlap
                  :value="props.student.events.filter(e => ((Date.parse(e.end_date) - Date.now() > 0) && (Date.parse(e.start_date) - Date.now() < 1e3 * 60 * 60 * 24 * 7 * 2))).length"
                  :color="props.student.events.filter(e => Date.parse(e.start_date) - Date.now() <= 0).length ? 'error' : 'primary'">
                    <v-chip @click="dialog_student_id = props.student.id; student_dialog = true">{{ nameify(props.student) }}</v-chip>
                </v-badge>
            </template>
        </lessons-table>
        <v-snackbar app v-model="snackbar">
            <v-icon left>error</v-icon>
            {{ snackbar_msg }}
        </v-snackbar>
        <v-dialog v-model="student_dialog" max-width="500" :fullscreen="$vuetify.breakpoint.xs">
            <student-dialog :student_id="dialog_student_id" mode="events" @close="student_dialog = false"/>
        </v-dialog>
        <v-progress-circular v-if="loading" :dark="$vuetify.theme.dark" indeterminate
          style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%)"/>
    </div>
</template>

<script>

import LessonsTable from './LessonsTable.vue'
import LessonsTableHeader from './LessonsTableHeader.vue'
import StudentDialog from './StudentDialog.vue'
import TrainingCell from './TrainingCell.vue'

export default {
    name: 'TrainerTrainingView',

    components: {
        LessonsTable,
        LessonsTableHeader,
        StudentDialog,
        TrainingCell
    },

    data: () => ({

        snackbar: false,
        snackbar_msg: '',
        student_dialog: false,
        dialog_student_id: null,
        loading: true

    }),

    computed: {
        lessons () {
            return this.$store.getters['trainer/lessons']
        },
        students () {
            return this.$store.getters['trainer/students'].slice().sort((a, b) => a.last_name > b.last_name)
        }
    },
    watch: {
    },
    methods: {
        async get_lessons () {
            try {
                await this.$store.dispatch('trainer/get_lessons');
            } catch (e) {
                this.snackbar_msg = 'Error fetching data';
                this.snackbar = true;
            }
        },
        nameify(student) {
            if (this.$vuetify.breakpoint.xs) {
                return student.first_name[0] + student.last_name[0]
            } else if (this.$vuetify.breakpoint.width < 1500) {
                return student.first_name.split(' ')[0] + ' ' + student.last_name[0] + '.'
            }
            return student.first_name + ' ' + student.last_name
        },
    },
    async created () {
        if (this.$store.getters['trainer/lessons'].length == 0) {
            await this.get_lessons();
        }
        this.loading = false;

        document.addEventListener("contextmenu", function (e) {
            e.preventDefault()
        }, false)
    }
};

</script>
